import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\EarlyAccessSignupController::__invoke
* @see app/Http/Controllers/EarlyAccessSignupController.php:20
* @route '/early-access'
*/
const EarlyAccessSignupController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: EarlyAccessSignupController.url(options),
    method: 'post',
})

EarlyAccessSignupController.definition = {
    methods: ["post"],
    url: '/early-access',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\EarlyAccessSignupController::__invoke
* @see app/Http/Controllers/EarlyAccessSignupController.php:20
* @route '/early-access'
*/
EarlyAccessSignupController.url = (options?: RouteQueryOptions) => {
    return EarlyAccessSignupController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\EarlyAccessSignupController::__invoke
* @see app/Http/Controllers/EarlyAccessSignupController.php:20
* @route '/early-access'
*/
EarlyAccessSignupController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: EarlyAccessSignupController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\EarlyAccessSignupController::__invoke
* @see app/Http/Controllers/EarlyAccessSignupController.php:20
* @route '/early-access'
*/
const EarlyAccessSignupControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: EarlyAccessSignupController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\EarlyAccessSignupController::__invoke
* @see app/Http/Controllers/EarlyAccessSignupController.php:20
* @route '/early-access'
*/
EarlyAccessSignupControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: EarlyAccessSignupController.url(options),
    method: 'post',
})

EarlyAccessSignupController.form = EarlyAccessSignupControllerForm

export default EarlyAccessSignupController